import { apiBff } from '@/api'

export interface ParamethorParameter {
  exception_id: string | null
  parameter_id: number
  parameter_name: string
  parameter_value: string
}

export async function getParameters(uid: string): Promise<ParamethorParameter[]> {
  return apiBff.callDirectBFF('GET', `paramethor/${encodeURIComponent(uid)}`)
}
